import { Routes } from '@angular/router';
import { LineSelectionComponent } from '@features/activity-types/transfer-liability/components/line-selection/line-selection.component';
import { TransferDetailsComponent } from '@features/activity-types/transfer-liability/components/transfer-details/transfer-details.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const transfer_liability_routes: Routes = [
  {
    path: 'line-selection',
    component: LineSelectionComponent,
    title: 'Select Line',
    data: { order_type_id: 13 }
  },
  {
    path: 'transfer-details',
    component: TransferDetailsComponent,
    title: 'Transfer Details',
    data: { order_type_id: 13 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 13 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 13 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
